export default __webpack_public_path__ + "static/media/Tutorial.39d3fdf8.svg";